import { render, staticRenderFns } from "./ProductPhoto.vue?vue&type=template&id=666f5e3e&"
import script from "./ProductPhoto.vue?vue&type=script&lang=js&"
export * from "./ProductPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ProductPhoto.vue?vue&type=style&index=0&id=666f5e3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports